import eventBus from './event.bus'
import userService from './user.service'
import notificacaoCacheService from './notificacao.cache.service'
import Helper from './helper.service'
import { isNativePlatform } from './platform.url.service'
import modoAlunoService from '../Services/ModoAluno.service'

export const TOUR_NOTIFICACOES_INICIAR = 'TourNotificacoesIniciar'
export const TOUR_NOTIFICACOES_ENCERRAR = 'TourNotificacoesEncerrar'
export const TOUR_NOTIFICACOES_PREPARAR_DESKTOP = 'TourNotificacoesPrepararDesktop'
export const TOUR_NOTIFICACOES_PREPARAR_MOBILE = 'TourNotificacoesPrepararMobile'
export const TOUR_NOTIFICACOES_MOBILE_MAX_WIDTH = 991
export const ROTA_TOUR_NOTIFICACOES_ALUNO = '/aluno/sala-de-aula/disciplina/atuais'
export const TOUR_NOTIFICACOES_SELETOR_ALVO = '#header-notificacoes-nav'
export const TOUR_NOTIFICACOES_SELETOR_ALVO_MOBILE = '#header-notificacoes-nav-mobile'

let tourNotificacoesDisparoEmAndamento = false

export function usarLayoutNotificacoesMobileHeader() {
  if (typeof window === 'undefined')
    return false
  if (isNativePlatform())
    return true
  return window.innerWidth <= TOUR_NOTIFICACOES_MOBILE_MAX_WIDTH
}

export function seletorAlvoTourNotificacoes() {
  return usarLayoutNotificacoesMobileHeader()
    ? TOUR_NOTIFICACOES_SELETOR_ALVO_MOBILE
    : TOUR_NOTIFICACOES_SELETOR_ALVO
}

/** @deprecated use tourDisponivelNotificacoes */
export function tourDisponivelWebDesktop() {
  return tourDisponivelNotificacoes() && !usarLayoutNotificacoesMobileHeader()
}

export function tourDisponivelNotificacoes() {
  return true
}

export function estaNaRotaTourNotificacoesAluno(route) {
  if (!route)
    return false

  const tipo = route.params?.tipo
  if (tipo) {
    if (tipo !== 'atuais')
      return false
    return true
  }

  const path = (route.path || window.location?.pathname || '').split('?')[0]
  const segments = path.split('/').filter(Boolean)
  const indiceDisciplina = segments.indexOf('disciplina')
  if (indiceDisciplina < 0)
    return false

  return segments[indiceDisciplina + 1] === 'atuais'
}

function usuarioPodeVerTourNotificacoes() {
  if (!userService.isAuthenticated())
    return false
  if (!userService.checkPermision('Mensagem'))
    return false

  const usuario = userService.getUser()
  if (!usuario)
    return false

  if (usuario.TipoUsuario === 'aluno' || modoAlunoService.checkModoAluno())
    return true

  const path = (window.location?.pathname || '').split('?')[0]
  return path.includes('/aluno/sala-de-aula/disciplina/atuais')
}

export async function aguardarElementoTourNotificacoes(seletor, timeoutMs = 10000) {
  const inicio = Date.now()
  while (Date.now() - inicio < timeoutMs) {
    const elemento = document.querySelector(seletor)
    if (elemento)
      return elemento
    await new Promise((resolve) => setTimeout(resolve, 80))
  }
  return null
}

async function dispararEventoTourNotificacoes(mensagens, notificacoes) {
  if (tourNotificacoesDisparoEmAndamento)
    return

  if (document.body.classList.contains('tour-notificacoes-ativo'))
    return

  tourNotificacoesDisparoEmAndamento = true

  try {
    await new Promise((resolve) => setTimeout(resolve, 80))

    eventBus.dispatchEvent(new CustomEvent(TOUR_NOTIFICACOES_INICIAR, {
      detail: { mensagens, notificacoes },
    }))
  } finally {
    window.setTimeout(() => {
      tourNotificacoesDisparoEmAndamento = false
    }, 5000)
  }
}

const NotificacaoTourAluno = {
  methods: {
    async tourNotificacoesDisciplinaAtuais() {
      if (!estaNaRotaTourNotificacoesAluno(this.$route))
        return

      if (!tourDisponivelNotificacoes())
        return

      if (!usuarioPodeVerTourNotificacoes())
        return

      const { mensagens, notificacoes } = await notificacaoCacheService.obterContagensNaoLidas({ forcar: true })

      if (mensagens <= 0 && notificacoes <= 0)
        return

      await this.$nextTick()
      await dispararEventoTourNotificacoes(mensagens, notificacoes)
    },
    async tourNotificacoesPosLogin() {
      await this.tourNotificacoesDisciplinaAtuais()
    },
  },
}

export default NotificacaoTourAluno
